import React from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import { Row, Preloader, Col } from 'core/components/Framework7';

const styles = {
  container: {
    // overflowY: 'auto',
    // overflowX: 'hidden',
    // height: '100%',
    // width: '100%',
    // position: 'relative',
    // paddingBottom: '30%',
  },
  preloader: {
    width: '100%',
    position: 'absolute !important',
    bottom: 'var(--toolbar-button-bottom)',
    textAlign: 'center',
    zIndex: '666'
  }
}

class InfiniteScroll extends React.PureComponent {
  static get defaultProps() {
    return {
      startPage: 0,
      hasMore: false,
      offset: 120,
      initialLoad: false,
      loading: true,
      className: ''
    }
  }

  /** @inheritdoc */
  constructor(props) {
    super(props)

    this.state = {
      page: props.startPage
    }

    this.getContainer = element => (this.container = element)
  }

  /** @inheritdoc */
  componentDidUpdate(prevProps) {
    const { loading, hasMore } = this.props

    if (
      loading !== prevProps.loading &&
      loading === false &&
      hasMore
    ) {
      this.loadIfNotEnough()
    }

    if (hasMore !== prevProps.hasMore && hasMore === false) {
      this.container.removeEventListener('scroll', this.handleOnScroll)
    } else if (hasMore !== prevProps.hasMore && hasMore === true) {
      this.container.addEventListener('scroll', this.handleOnScroll)
    }
  }

  /** @inheritdoc */
  componentDidMount() {
    this.container.addEventListener('scroll', this.handleOnScroll)

    if (this.props.initialLoad && this.props.hasMore) {
      this.loadMore()
    }
  }

  /** @inheritdoc */
  componentWillUnmount() {
    this.container.removeEventListener('scroll', this.handleOnScroll)
  }

  /**
   * Handle scroll event
   * @param {Object} e event
   */
  handleOnScroll(e) {
    let { clientHeight, scrollTop, scrollHeight } = e.target
    let { offset, onScroll } = this.props

    if (onScroll) onScroll(e)

    if (
      clientHeight + scrollTop + (clientHeight * 2) >= scrollHeight &&
      this.props.hasMore &&
      !this.props.loading
    ) {
      this.loadMore()
    }
  }

  /**
   * Load more items if viewport not
   */
  loadIfNotEnough() {
    setTimeout(() => {
      let { clientHeight, scrollTop, scrollHeight } = this.container
      let { offset, loading, hasMore } = this.props

      if (clientHeight + scrollTop + (clientHeight * 2) >= scrollHeight && hasMore && !loading) {
        this.loadMore()
      }
    }, 10)
  }

  /**
   * Load more items
   */
  loadMore() {
    this.setState(
      prevState => ({
        page: prevState.page + 1
      }),
      () => {
        this.props.loadMore(this.state.page)
      }
    )
  }

  /** @inheritdoc */
  render() {
    const { className, children, component, loading } = this.props

    const El = component || 'div'

    return (
      <div className={className} ref={this.getContainer}>
        <El style={{ width: "100%" }}>
          {children ? children : null}
        </El>
        {loading &&
          <Col width="100" style={styles.preloader}>
            <Preloader />
          </Col>
        }
      </div>
    )
  }
}

InfiniteScroll.propTypes = {
  loadMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
  offset: PropTypes.number,
  initialLoad: PropTypes.bool,
  loading: PropTypes.bool,
  startPage: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onScroll: PropTypes.func
}

export default autobind(InfiniteScroll)
